module.exports = __webpack_public_path__ + "img/chart-demo1.028117ae.svg";